var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 45,
    viewBox: "0 0 70 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_594_1477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6926 14.6343C33.6926 17.1373 33.1182 19.4352 31.9692 21.5278C30.8203 23.5795 29.0559 25.2413 26.676 26.5133C24.2961 27.7854 21.3417 28.4214 17.8129 28.4214H11.2886V43.9318H0.763672V0.724121H17.8129C21.2596 0.724121 24.173 1.3191 26.5529 2.50905C28.9328 3.69901 30.7177 5.34033 31.9077 7.43301C33.0976 9.52569 33.6926 11.9261 33.6926 14.6343ZM17.0127 20.0506C19.0233 20.0506 20.521 19.5788 21.5058 18.635C22.4906 17.6912 22.983 16.3577 22.983 14.6343C22.983 12.9109 22.4906 11.5773 21.5058 10.6336C20.521 9.68982 19.0233 9.21794 17.0127 9.21794H11.2886V20.0506H17.0127Z",
    fill: "#504F4F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_594_1477)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1488 36.6439H56.2748L58.8598 44.2761H70.0003L54.3667 1.06836H42.1799L26.5464 44.2761H37.5637L40.1488 36.6439ZM41.7481 18.0406L41.5697 31.2691L48.2731 24.5656L54.9766 31.2691L54.7982 18.0406L48.2731 11.5156L41.7481 18.0406Z",
    fill: "#1A237E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_594_1477",
    x: 0.763672,
    y: 0.724121,
    width: 38.1484,
    height: 48.4269,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.21942,
    dy: 5.21942
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.91456
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_594_1477"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_594_1477",
    x: 23.9367,
    y: 1.06836,
    width: 48.6733,
    height: 45.8172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.60971,
    dy: 2.60971
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.21942
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823778 0 0 0 0 0.37448 0 0 0 0 0.687956 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_594_1477"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.60971,
    dy: 2.60971
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.21942
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.372549 0 0 0 0 0.686275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_594_1477",
    result: "effect2_innerShadow_594_1477"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaIcon);
export default __webpack_public_path__ + "static/media/pa-icon.5308e2086a5438ef5c63dd8e26bf9eda.svg";
export { ForwardRef as ReactComponent };